export enum LockStatus {
  HARD_BLOCKED = 'HARD_BLOCKED',
  BLOCKED = 'BLOCKED',
  UNBLOCKED = 'UNBLOCKED',
}
